/* 预约相关 */
const state = {
    package: {}, //当前选中的套餐
    orderItems: [], //预约相关的体检项目，包含加项/减项
    customizedProject: {}, //订制化的体检套餐
}

const mutations = {
    SET_PACKAGE(state, data) {
        state.package = data;
    },
    SET_CUSTOMIZED_PROJECT(state, data) {
        state.customizedProject = data;
    }
}

const actions = {
    setPackage({
        commit
    }, data) {
        commit("SET_PACKAGE", data);
    },
    setCustomizedProject({
        commit
    }, data) {
        commit("SET_CUSTOMIZED_PROJECT", data);
    }
}


export default {
    namespaced: true,
    state,
    // getters,
    mutations,
    actions
}